module.exports = __webpack_public_path__ + "img/customerService.19b499e.png";